//@ts-ignore
import GithubIcon from '../icons/github.png';
//@ts-ignore
import LinkedInIcon from '../icons/linkedin.svg';
//@ts-ignore
import TwitterIcon from '../icons/twitter.svg';

export const externalLinks = [
  {
    label: 'LinkedIn',
    icon: LinkedInIcon,
    url: 'https://www.linkedin.com/in/meetxpress'
  },
  {
    label: 'Github',
    icon: GithubIcon,
    url: 'https://www.github.com/meetxpress'
  },
  {
    label: 'Twitter',
    icon: TwitterIcon,
    url: 'https://x.com/kuchbhimeet'
  }
];
